// This import loads the firebase namespace along with all its type information.
import System from './system-model'

export async function load_systems(): Promise<System[]> {
  throw 'Not implemented'
}

export async function delete_system(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_system(): Promise<System> {
  throw 'Not implemented'
}
